/**
 * Implements a Trending line in header
 * Data located in useTrending.ts
 */
import { useSelector } from 'react-redux';
import { IStore } from '../../../reducers';
import TrendingCoinMobile from './TrendingCoin';
import flash from '../../../assets/images/flash.svg';
import Loader from '../../common/Loader';
import Image from '../../../atoms/Image';
import './styles.scss';

const TrendingMobile = () => {
  const {
    items,
    isError,
    loading
  } = useSelector((state: IStore) => state.trendingReducer);

  return (
    <div className='trending__mobile'>
      <div className='trending__mobile__title'>
        <Image src={flash} size='m' />
      </div>
      {loading ? (
        <Loader />
      ) : isError ? null : (
        <div className='trending__mobile__items'>
          {items.map((item) => (
            <TrendingCoinMobile key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TrendingMobile;
